import React from "react";
import PropTypes from "prop-types";
import ButtonRadio from "wonderbly-components/lib/ButtonRadio";
import CharacterThumbnail from "../CharacterThumbnail";

const CharacterNavItem = (props) => (
  <ButtonRadio
    disabled={props.isDisabled}
    id={`${props.character}-${props.index}`}
    value={props.character}
    onChange={props.onChange}
    className="character-picker-nav-item"
    name="characterSelection"
  >
    <div className="character-picker-nav-item-inner">
      <CharacterThumbnail src={props.thumbnail} alt={props.character} />
      <div className="character-picker-nav-item-label">{props.character}</div>
      <div
        className={`button ${
          props.isDisabled ? "button--disabled" : "button--green"
        }`}
      >
        {props.isDisabled ? props.inUse : props.select}
      </div>
    </div>
  </ButtonRadio>
);

CharacterNavItem.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  character: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  thumbnail: PropTypes.string.isRequired,
  inUse: PropTypes.string.isRequired,
  select: PropTypes.string.isRequired,
};

export default CharacterNavItem;
